import React from "react"
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import Select from "react-select";
import SelectComp from "../../NewComponent/Select/Select";

export default function SelectComponentForDomainSpecificInCMexpert()
{
	const expertOverview = useSelector((state)=>state.expertOverviewCmReducer)
	const dispatch = useDispatch();
	const {getDurationForMonthsForDomainSpecificGraph } = bindActionCreators(Actions, dispatch);
	// const array1 = [
	// 	{ label: 'Last Month', value: null },
	// 	{ label: 'Last 3 Months', value: '3months' }
	// 	, { label: 'Last 6 months', value: '6months' },
	// 	{ label: 'Last 1 Year', value: '12months' },
	// 	{ label: 'Year To Date', value: '-1months' }
	// ]
		const array1 = [
		{  value: null,label: 'Last Month', },
		{ value: '3months' ,label: 'Last 3 Months', }
		, { value: '6months',label: 'Last 6 months',  },
		{  value: '12months',label: 'Last 1 Year', },
		{ value: '-1months',label: 'Year To Date' }
	]

	const customStyles = {
		control: (base, state) => ({
			...base,
			marginBottom:5,
			fontSize: 13,
			minHeight: 32,
			height: 32,
			borderColor: state.isFocused ? 'none' : null,
			minWidth: 120,
			border: '1px solid lightgrey',
			boxShadow: 'none',
			border: state.isFocused ? '1px solid lightgrey' : '1px solid lightgrey',
			"&:hover": { border: '1px solid lighgrey' }
		}),
		menuList: (base) => ({
			...base,
			fontSize: 13,
			padding: 0
		}),
		option: (base, state) => ({
			...base,
			backgroundColor: (state.isSelected && 'var(--viz_light_color)'),
			"&:hover": { backgroundColor: state.isSelected ? null : '#ececec' },
			cursor: 'pointer'
		}),
		dropdownIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
		  clearIndicator: (styles) => ({
			...styles,
			paddingTop: 0,
			paddingBottom: 0,
			color: "lightgray",
		  }),
	};

	const onChangeData = (data) => {
		// console.log(data,'check what data is going')
		getDurationForMonthsForDomainSpecificGraph(data)
	}


	return (
		<>
			{/* <Select
				className="basic-single"
				classNamePrefix="select"
				defaultValue={array1[0]}
				isDisabled={false}
				isClearable={false}
				isSearchable={true}
				name="color"
				options={array1}
				styles={customStyles}
				onChange={onChangeData}
				value={expertOverview.domainSpecificDuration}
			/> */}
			<SelectComp val={expertOverview.domainSpecificDuration} isString={false} defaultValue={array1[0]} onChangeFunc={onChangeData} labelInValue={true} width={'100%'} options={array1}  />
		</>
	)
}